//Called from _CalendarSearchFilters.js
function applyAdvancedFilters() {
    if ($('#filterForm').valid()) {
        var data = getDataFromFilterControls(null, null, false);
        var url = "/CalendarList" + getFilterParams(data);

        window.location = url;
    }
}